import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6fe7a58e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pages-pc"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-arrow-left"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 2,
  class: "dot"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-dotdotdot"
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-arrow-right"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_row = _resolveComponent("van-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_row, {
    class: "pages-pc-row",
    align: "center",
    justify: "center"
  }, {
    default: _withCtx(() => [$setup.showFirst ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      class: "first",
      onClick: _cache[0] || (_cache[0] = $event => $setup.togoPage(1))
    }, "1...")) : _createCommentVNode("", true), $setup.showPrev ? (_openBlock(), _createElementBlock("a", {
      key: 1,
      class: "prev",
      onClick: _cache[1] || (_cache[1] = $event => $setup.togoPage($setup.displayPage - 1))
    }, _hoisted_3)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.beforePages, beforePage => {
      return _openBlock(), _createElementBlock("a", {
        class: "",
        key: 'p-' + beforePage,
        onClick: $event => $setup.togoPage(beforePage)
      }, _toDisplayString(beforePage), 9, _hoisted_4);
    }), 128)), _createElementVNode("strong", null, _toDisplayString($setup.displayPage), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.afterPages, afterPage => {
      return _openBlock(), _createElementBlock("a", {
        class: "",
        key: 'p-' + afterPage,
        onClick: $event => $setup.togoPage(afterPage)
      }, _toDisplayString(afterPage), 9, _hoisted_5);
    }), 128)), $setup.showDot ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true), $setup.showLast ? (_openBlock(), _createElementBlock("a", {
      key: 3,
      class: "last",
      onClick: _cache[2] || (_cache[2] = $event => $setup.togoPage($props.total_page))
    }, _toDisplayString($props.total_page), 1)) : _createCommentVNode("", true), $setup.showNext ? (_openBlock(), _createElementBlock("a", {
      key: 4,
      class: "nxt",
      onClick: _cache[3] || (_cache[3] = $event => $setup.togoPage($setup.displayPage + 1))
    }, _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(['d-flex', {
        'd-none': !$props.showJumpWithOnlyOnePages && $props.total_page < 2
      }])
    }, [_createElementVNode("label", null, [_withDirectives(_createElementVNode("input", {
      type: "text",
      class: "input-page",
      placeholder: "页码",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.inputPage = $event),
      onKeydown: _cache[5] || (_cache[5] = _withKeys($event => $setup.togoPage($setup.inputPage), ["enter"])),
      onfocus: "this.value=''"
    }, null, 544), [[_vModelText, $setup.inputPage]])]), _createElementVNode("span", {
      class: "button-togo-page",
      onClick: _cache[6] || (_cache[6] = $event => $setup.togoPage($setup.inputPage))
    }, "跳转")], 2)]),
    _: 1
  })]);
}